// extracted by mini-css-extract-plugin
export default {"header":"Header_header__9BTnO","h1":"Header_h1__zn83m","h2":"Header_h2__w-UZE","logo":"Header_logo__npUeQ"};